<template>
  <header>
    <div class="main-header">
      <div class="alya-logo" @click="$router.push('/')"><b class="vheart">VHEART</b> powered by ALYARED</div>
      <error-overlay v-if="showError"></error-overlay>
      <div class="user-tokens">
        <div class="token-box purchased">{{tokens ? tokens.purchased : ''}} Tokens</div>
        <div class="token-box available">{{tokens ? tokens.available : ''}} Available</div>
        <div class="token-box spent">{{tokens ? tokens.spent : ''}} Spent</div>
      </div>
      <v-popover class="user-info">
        <div class="user-image" tooltip-target b3>
          {{userInfo && userInfo.full_name ? userInfo.full_name.charAt(0).toUpperCase() : ''}}
          <!--<div class="user-notification"></div>-->
        </div>
        <template slot="popover">
          <div class="user-popover">
            <div class="user-popover-info">
              <div class="user-image">{{userInfo && userInfo.full_name ? userInfo.full_name.charAt(0).toUpperCase() : ''}}</div>
              <div class="user-info-text">
                <div class="username">{{userInfo ? userInfo.full_name : ''}}</div>
                <div class="user-email">{{userInfo ? userInfo.email : ''}}</div>
              </div>
            </div>
            <div class="user-popover-actions">
              <div class="user-action-option" @click="doLogout">
                <div class="icon-logout"></div>
                Sign out
              </div>
            </div>

          </div>
        </template>
      </v-popover>
      <!--<div class="menu-container">
        <div class="menu-btn"></div>
      </div>-->
    </div>
    <div class="breadcrumbs-container" v-if="showCrumbs">
      <div class="breadcrumbs">
        <router-link class="crumb crumb-home" to="/">
          <div class="home-icon"></div>
        </router-link>
        <router-link class="crumb" v-for="crumb in crumbs" :to="crumb.to" :key="crumb.to">
          <div class="crumb-text">{{crumb.text}}</div>
          <div class="crumb-separator"></div>
        </router-link>
      </div>
    </div>  
  </header>
  
</template>

<script>
import ErrorOverlay from '@/components/commons/ErrorOverlay'

export default {
  name: 'MainHeader',
  components: {ErrorOverlay},
  created() {
    this.$store.dispatch('updateOrganisationTokens')
    this.$store.dispatch('storeUser')
  },
  computed: {
    crumbs () {
      let breadcrumbArray = []
      let routePointer = this.$route
      breadcrumbArray.push(routePointer.meta.breadcrumbsFn(this.$store.state.paramsData))

      while(routePointer.meta.parentView){
        routePointer = this.$router.options.routes.find(r => r.name == routePointer.meta.parentView)
        breadcrumbArray.push(
          routePointer.meta.breadcrumbsFn(this.$store.state.paramsData)
        )
      }
      breadcrumbArray = this.handleTrialResultsCrumb(breadcrumbArray)
      return breadcrumbArray.reverse()
    },
    showCrumbs (){
      return this.$route.name != 'ProjectsView'
    },
    showError() {
      return this.$store.state.error != ''
    }
  },
  asyncComputed:{
    userInfo () {
      return this.$store.state.user
    },
    tokens () {
      return this.$store.state.organisationTokens
    }
  },
  methods: {
    doLogout () {
      localStorage.removeItem('elem-session-token')
      this.$store.commit('projects/resetData')
      this.$store.commit('projectFields/resetData')
      this.$store.commit('trialOptions/resetData')

      this.$router.push({path: '/login'})
    },
    handleTrialResultsCrumb(breadcrumbArray) {
      let trialForCrumb = this.$store.state.trialToShowInResultsCrumb
      if (typeof trialForCrumb == 'string'
        && trialForCrumb.includes('trial#')
        && this.$store.state.paramsData.project) {
        let trialId = parseInt(trialForCrumb.split('#')[1])
        let trialName = this.$store.state.paramsData.project.trials.find(trial => trial.id == trialId).name
        let trialResultsCrumbText = `Trial ${trialName}`
        if (breadcrumbArray.length <= 3) breadcrumbArray.unshift({text: trialResultsCrumbText, to: ''})
        else breadcrumbArray.splice(1, 0, {text: trialResultsCrumbText, to: `/project/${this.$store.state.paramsData.project.id}/results/trial`})
      } else {
        let trialCrumbIndex = breadcrumbArray.findIndex(crumb => crumb.text.includes('Trial'))
        breadcrumbArray.splice(trialCrumbIndex,0)
      }
      return breadcrumbArray
    }
  }
}
</script>

<style  lang="stylus" scoped>

.main-header
  align-items: center
  background: $charade
  background: linear-gradient(90deg, $charade 0, $comet 100%)
  border-bottom: 1px solid rgba(255, 255, 255, 0.2)
  color: #fff
  display: flex
  // height: $header-height
  flex: 0 0 $header-height
  position: relative

  &:before
    background-color: $radical-red
    content: ""
    height: 100%
    left: 0
    position: absolute
    top: 0
    width: 4px

  .alya-logo
    //background-image: url("~@/assets/alyared-logo-white.svg")
    //background-position: center center
    //background-repeat: no-repeat
    cursor: pointer
    margin-left: 30px
    width: 500px
    m-font-size(18,22)
    color: $radical-red
    .vheart
      color: white

  .user-tokens
    width: 17%
    display: flex
    m-font-size(12,14)
    margin-left: auto
    .token-box
      width: 33%
      text-align: center
      padding: 8px
      margin: 0 4px
      border-radius: 5px
      &.available
        color: rgb(41,236,37)
        background-color: rgba(41,236,37,0.2)
      &.spent
        color: rgb(255,110,110)
        background-color: rgba(255,98,98,0.2)
      &.purchased
        border-style: solid
        border-color: white
        border-width: 1px

  .user-info
    align-items: center
    display: flex
    height: $header-height
    justify-content: center
    width: @height
    cursor pointer
    .user-image
      cursor pointer
      background-color: #737A92
      border-radius: 50%
      height: 32px
      position: relative
      width: @height
      display: flex
      justify-content: center
      align-items: center
      m-font-size(16,16)
      color #fff
      .user-notification
        background-color: $radical-red
        border: 1px solid $comet
        border-radius: 50%
        bottom: 0
        height: 15px
        position: absolute
        right: 0
        width: @height

  .menu-container
    align-items: center
    background-color: rgba($titan-white, 0.2)
    display: flex
    height: $header-height
    justify-content: center
    width: @height

    .menu-btn
      cursor: pointer
      m-icon("menu", 17)

.breadcrumbs-container
  height 35px
  background $titan-white
  border-bottom 1px solid $mystic
  padding-left: 40px
  display flex
  align-items center
  +m-breakpoint(sm md)
    padding-left: 20px
  .breadcrumbs
    align-items: center
    display: flex

    .crumb
      align-items: center
      color: $charade
      display: flex
      text-decoration: none

      &.router-link-active
        cursor: default
        font-weight $fw-bold

      &:not(:last-child)
        color: rgba($charade, 0.75)
        transition: color 0.25s ease-in-out
        font-weight $fw-regular


        &:hover
          color: $charade

          .crumb-text
            &:after
              width: 100%

        .crumb-separator
          display: block

    .crumb-text
      m-font-size(16, 20)
      cursor: pointer
      position: relative

      &:after
        background-color: $charade
        bottom: -2px
        content: ""
        height: 2px
        left: 0
        position: absolute
        transition: width 0.25s ease-in-out
        width: 0

    .crumb-separator
      display: none
      height: 14px
      margin-left: (@height / 2)
      margin-right: (@height / 2)
      m-chevron("right", (@height / 2), 1, rgba($gull-gray, 0.75))
      width: @height
  .home-icon
    m-icon("home", 14)
    cursor pointer
</style>

<style lang="stylus">
.user-popover
  .user-popover-info
    border-bottom 1px solid $mystic
    display flex
    padding 12px
    align-items center
    .user-image
      background-color: #737A92
      border-radius: 50%
      height: 32px
      position: relative
      width: @height
      display: flex
      justify-content: center
      align-items: center
      m-font-size(16,16)
      color #fff
    .user-info-text
      display block
      margin-left 8px
      .username
        m-font-size(16,20)
        font-weight $fw-semi-bold
      .user-email
        m-font-size(12,15)
        font-weight $fw-light
  .user-action-option
    cursor: pointer
    m-font-size(13, 16)
    padding: 10px
    display flex
    align-items center
    .icon-logout
      m-icon("logout", 16)
      margin-right 5px

    &:hover
      background-color: $mystic
</style>